export const MIN_CHARACTERS_PASSWORD = 12;
export const MAX_CHARACTERS_PASSWORD = 30;
export const MIN_SPECIAL_CHARACTERS_PASSWORD = 1;

// This regex does not match whitespaces characters
// eslint-disable-next-line no-useless-escape
export const RGX_SPECIAL_CHARACTERS = `[^a-zA-Z0-9\s]`;
